export const APP_STARTED = 'APP_STARTED';
export const AUTOSAVE = 'AUTOSAVE';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const EDITOR_INITIALIZED = 'EDITOR_INITIALIZED';
export const FOCUS_ON_FIELD = 'FOCUS_ON_FIELD';
export const FLOATING_ALERT_MESSAGE = 'FLOATING_ALERT_MESSAGE';
export const LOG_INTERACTION = 'LOG_INTERACTION';
export const LOG_TINYMCE_INTERACTION = 'LOG_TINYMCE_INTERACTION';
export const OPEN_ECOMMERCE_CONNECT_PANEL = 'OPEN_ECOMMERCE_CONNECT_PANEL';
export const FETCH_ECOMM_STORES = 'FETCH_ECOMM_STORES';
export const OPEN_FILE_MANAGER = 'OPEN_FILE_MANAGER';
export const CLOSE_FILE_MANAGER = 'CLOSE_FILE_MANAGER';
export const OPEN_MANAGE_CAN_SPAM_MODAL = 'OPEN_MANAGE_CAN_SPAM_MODAL';
export const RENDER_MODULE = 'RENDER_MODULE';
export const RENDER_MODULE_WITH_CONTEXT = 'RENDER_MODULE_WITH_CONTEXT';
export const TRACK_APP_LIFECYCLE_TIMESTAMP = 'TRACK_APP_LIFECYCLE_TIMESTAMP';
export const TRACK_PREVIEW_METRICS = 'TRACK_PREVIEW_METRICS';
export const UPLOAD_FILE = 'UPLOAD_FILE';
export const UPDATE_CAN_SPAM_SETTING_ID = 'UPDATE_CAN_SPAM_SETTING_ID';
export const SET_USER_ATTRIBUTE = 'SET_USER_ATTRIBUTE';
export const SET_HUB_SETTING = 'SET_HUB_SETTING';
export const IFRAME_CLICKED = 'IFRAME_CLICKED';
export const CLOSE_HEADER_MENU = 'CLOSE_HEADER_MENU';
export const OPEN_SAVE_SECTION_MODAL = 'OPEN_SAVE_SECTION_MODAL';
export const FETCH_CUSTOM_MODULES = 'FETCH_CUSTOM_MODULES';
export const RENDER_FAILED = 'RENDER_FAILED';
export const LBUI_READY = 'LBUI_READY';
export const FLEX_AREA_INDEX = 'FLEX_AREA_INDEX';
export const OPEN_MODAL = 'OPEN_MODAL';
export const DROP_SAVED_SECTION_ON_SECTION = 'DROP_SAVED_SECTION_ON_SECTION';
export const FETCH_SAVED_SECTIONS = 'FETCH_SAVED_SECTIONS';
export const BUTTON_MODULE_VIEW_CHANGE = 'BUTTON_MODULE_VIEW_CHANGE';
export const WAIT_FOR_SIDEBAR_IFRAME_LOADED = 'WAIT_FOR_SIDEBAR_IFRAME_LOADED';
export const ADD_MODULE_SIDEBAR_LOADED = 'ADD_MODULE_SIDEBAR_LOADED';
export const CAPTURE_PAGE_EVENT = 'CAPTURE_PAGE_EVENT';

// in page action
export const INPAGE_REDUX_ACTION = 'INPAGE_REDUX_ACTION';
export const PARENT_APP_MESSAGING_READY = 'parentAppMessagingReady';
export const INPAGE_APP_INITIALIZATION_STARTED = 'inpageAppInitializationStarted';
export const LBUI_I18N_INIT = 'LBUI_I18N_INIT';